export default {
  dynamics: '{{change}} vs Vorwoche',
};
